import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@mui/material";
import { FC } from "react";
import styles from "./SecondConfirmModal.module.scss";
import { RedWarnIcon, SecondWarnIcon } from "assets/icons";

interface ISecondConfirmModalProps {
  open: boolean;
  title: string;
  description: string;
  status?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  danger?: boolean;
  onCancel: () => void;
  closeOnBackdropClick?: boolean;
  isLoading?: boolean;
}

const SecondConfirmModal: FC<ISecondConfirmModalProps> = ({
  open,
  title,
  description,
  confirmText,
  cancelText,
  status,
  onConfirm,
  onCancel,
  danger,
  closeOnBackdropClick,
  isLoading,
}) => {
  const handleClose = () => {
    if (closeOnBackdropClick) {
      onCancel();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={styles.dialogWindow}
      PaperProps={{
        sx: {
          position: "relative",
          borderRadius: "16px",
          backgroundColor: status ? "#FFD1CF" : "#F6EBDD",
          marginTop: "64px",
          boxSizing: "border-box",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "32px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 64,
          height: 64,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
        }}
      >
        {status ? (<RedWarnIcon />) : (<SecondWarnIcon />)}
      </Box>

      <Box
        sx={{
          marginTop: "64px",
          paddingTop: "35px",
          borderRadius: "16px 16px 0 0",
          backgroundColor: "#FFFFFF",
        }}
      >
        <DialogTitle
          sx={{
            paddingTop: "16px",
            color: "#3E444A",
            fontSize: "19px",
            fontWeight: 600,
            textAlign: "center",
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            maxWidth: "90%",
            margin: "0 auto",
          }}
        >
          {title}
        </DialogTitle>
      </Box>

      <DialogContent
        sx={{
          width: {
            xs: "100%",
            sm: "90%",
            md: "590px",
          },
          backgroundColor: "#FFFFFF",
          boxSizing: "border-box",
          padding: {
            xs: "12px 16px",
            md: "16px 0",
          },
        }}
      >
        <DialogContentText
          sx={{
            color: "#68717B",
            fontWeight: 500,
            fontSize: {
              xs: "14px",
              md: "16px",
            },
            lineHeight: 1.5,
            textAlign: "center",
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            maxWidth: "90%",
            margin: "0 auto",
          }}
        >
          {description}
        </DialogContentText>
      </DialogContent>

      <Divider sx={{ backgroundColor: "#FFFFFF" }} />

      <DialogActions
        sx={{
          backgroundColor: "#FFFFFF",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          margin: "0 auto",
        }}
      >
        <Button
          onClick={onCancel}
          sx={{
            mt: 2,
            width: "95%",
            textTransform: "capitalize",
            fontWeight: 500,
            fontFamily: "Raleway",
            borderRadius: "12px",
            color: "#0090D1",
            backgroundColor: "#F0F8FF",
          }}
        >
          {cancelText}
        </Button>

        <Button
          autoFocus
          variant="contained"
          onClick={onConfirm}
          disabled={isLoading}
          sx={{
            mt: 1,
            mb: 3,
            width: "95%",
            fontFamily: "Raleway",
            fontWeight: 500,
            fontSize: "15px",
            borderRadius: "12px",
            backgroundColor: danger ? "#d14100" : "#0090D1",
            textTransform: "none",
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecondConfirmModal;
